import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import Project from '@/projects/entities/project'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import moment from 'moment'
import DiagramConfiguration from '../entities/diagram-configuration'

class ProjectsService {

  public async findAsync(id: string) {
    const res = await axios.get<Project>(`project/${id}`)
    return Responses.obj(res)
  }

  public async findDiagramConfiguration(id: string) {
    const res = await axios.get<DiagramConfiguration>(`project/diagramConfiguration/${id}`)
    return Responses.obj(res)
  }

  public async findAllAsync(text: string, includeArchived: boolean, paging: PaginationRequest) {
    const params = {
      text,
      includeArchived,
      paging,
    };
    const res = await axios.post<PaginationResponse<Project>>('project', params)
    return Responses.pagedList(res)
  }

  public async createAsync(entity: Project) {
    const res = await axios.post<Project>(`project/create`, entity)
    return Responses.obj(res)
  }

  public async updateAsync(entity: Project) {
    const res = await axios.put<Project>(`project/update`, entity)
    return Responses.obj(res)
  }

  public async updateStatusAsync(id: string, status: number) {
    const res = await axios.put<Project>(`project/updateStatus`, { id, status })
    return Responses.obj(res)
  }

  public async duplicateAsync(id: string, status: number) {
    const res = await axios.post<Project>(`project/duplicate`, { id })
    return Responses.obj(res)
  }

  public async updateDiagramConfigurationAsync(id: string, config: DiagramConfiguration) {
    const res = await axios.put<Project>(`project/updateDiagramConfiguration?id=${id}`, config)
    return Responses.obj(res)
  }

  public async updateImageAsync(project: Project) {
    if (!project.image) {
      return
    }
    const formData = new FormData()
    formData.append('id', project.id)
    formData.append('file', project.image, project.image.name)
    await axios.post(`project/updateImage`, formData)
  }
}

export default new ProjectsService()
